import React from 'react';
import {withRouter} from 'react-router-dom';

class UploadFile extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="container">
                This is upload Section
            </div>
        )
    }
}

export default withRouter(UploadFile);